"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoreDetailsExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const utils_1 = require("../../../utils");
const marketplace_1 = require("../../../store/marketplace");
const getIncludesParams_1 = require("../../../shared/getIncludesParams");
const getStoreDetails = toolkitRaw.createAsyncThunk('store/fetch_details', async (data, { rejectWithValue, dispatch }) => {
    var _a, _b, _c, _d, _e;
    try {
        const headers = {};
        if ((_b = (_a = data.setting) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.bearerToken) {
            headers['Authorization'] = 'Bearer ' + ((_d = (_c = data.setting) === null || _c === void 0 ? void 0 : _c.headers) === null || _d === void 0 ? void 0 : _d.bearerToken);
            headers['Auth0-IdToken'] = ((_e = data.setting) === null || _e === void 0 ? void 0 : _e.headers.idToken) || '';
        }
        // TODO: move this to marketplace action
        if (data === null || data === void 0 ? void 0 : data.owner_id) {
            const response = await services_1.default.get(`/api/market/users/${data.owner_id || 'acme'}`, {
                headers,
                params: {
                    includes: (0, getIncludesParams_1.getDefaultIncludesParams)('market_user'),
                },
            });
            const payload = (0, utils_1.deserialize)(response.data);
            dispatch((0, marketplace_1.updateOwner)(payload.data));
            return payload.data;
        }
        const response = await services_1.default.get(`/api/stores/${data.store_domain || 'acme'}`, {
            params: {
                includes: (0, getIncludesParams_1.getDefaultIncludesParams)('stores_store'),
            },
        });
        const payload = (0, utils_1.deserialize)(response.data);
        return payload.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getStoreDetailsExtraReducers = (builder) => {
    builder.addCase(getStoreDetails.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(getStoreDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.data = action.payload;
    });
    builder.addCase(getStoreDetails.rejected, (state) => {
        state.loading = false;
        state.error = true;
    });
};
exports.getStoreDetailsExtraReducers = getStoreDetailsExtraReducers;
exports.default = getStoreDetails;
//# sourceMappingURL=index.js.map